<ul class="queue-list">
    <li class="subheader">Fornecedores - Fila de espera - Total: {{queues.length}}</li>
    <ngx-chat-list-item *ngFor="let queue of queues;" [item]="queue"></ngx-chat-list-item>
</ul>